// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { DocumentText, I24Support, LampOn, Profile2User, TimerStart } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  firstSteps: TimerStart,
  documentation: DocumentText,
  formation: LampOn,
  support: I24Support,
  accompaniment: Profile2User
};

// ==============================|| MENU ITEMS - OTHERS ||============================== //

const others: NavItemType = {
  id: 'others-group',
  title: <FormattedMessage id="common.menu.others.group" />,
  type: 'group',
  children: [
    {
      id: 'first-steps',
      title: <FormattedMessage id="common.menu.others.firstSteps" />,
      type: 'item',
      icon: icons.firstSteps
      // chip: {
      //   label: 'gitbook',
      //   color: 'info',
      //   size: 'small'
      // }
    },
    {
      id: 'documentation',
      title: <FormattedMessage id="common.menu.others.academy" />,
      type: 'item',
      // url: 'https://habihub.es/academy/',
      // url: 'https://landinghabihub-1f0bo91t92.live-website.com/academy/',
      url: 'https://academy.habihub.com',
      icon: icons.documentation,
      external: true,
      target: true
      // chip: {
      //   label: 'gitbook',
      //   color: 'info',
      //   size: 'small'
      // }
    },
    // {
    //   id: 'formation',
    //   title: <FormattedMessage id="common.menu.others.training" />,
    //   type: 'item',
    //   url: 'https://habihub.es/documentacion-plataforma/',
    //   icon: icons.formation,
    //   external: true,
    //   target: true
    // },
    {
      id: 'support',
      title: <FormattedMessage id="common.menu.others.support" />,
      type: 'item',
      icon: icons.support
      // chip: {
      //   label: 'gitbook',
      //   color: 'info',
      //   size: 'small'
      // }
    }
    // {
    //   id: 'accompaniment',
    //   title: <FormattedMessage id="common.menu.others.accompaniment" />,
    //   type: 'item',
    //   icon: icons.accompaniment
    // }
  ]
};

export default others;
